export default {
  state: { menuNav: true },
  mutations: {
    setMenuNav (state, value) {
      state.menuNav = value
    }
  },
  actions: {
    showMenuNav ({ commit }) {
      commit('setMenuNav', true)
    },
    hideMenuNav ({ commit }) {
      commit('setMenuNav', false)
    }
  },
  getters: {
    menuNav (state) {
      return state.menuNav
    }
  }
}
